// extracted by mini-css-extract-plugin
export default {"appContainer":"MainLayout_appContainer__6vcqg","mainContent":"MainLayout_mainContent__0R7Mf"};